import isEqual from 'lodash/isEqual.js'
import { createRouter, createWebHistory } from 'vue-router'
import { afterEach, beforeEach } from './guards'
import { routes } from './routes'

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (!isEqual(to.params, from.params) || to.name !== from.name) {
      return { top: 0 }
    }
  }
})

router.beforeEach(beforeEach)
router.afterEach(afterEach)
